import { render } from "./BonusTable.vue?vue&type=template&id=eb5e41ac&scoped=true"
import script from "./BonusTable.vue?vue&type=script&lang=js"
export * from "./BonusTable.vue?vue&type=script&lang=js"

import "./BonusTable.vue?vue&type=style&index=0&id=eb5e41ac&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb5e41ac"]])

export default __exports__